import { configUserCenter, login, logout } from '@haier/iam'

interface IAMConfig {
  ssoUrl: string
  clientId: string
  tokenUrl: string
  appId: string
  redirectUri?: string
  exitUrl: string
}

/**
 * 初始化 IAM SDK
 * @param config IAM 配置
 */
export function initIAM(config: IAMConfig) {
  configUserCenter({
    ssoUrl: config.ssoUrl,
    clientId: config.clientId,
    tokenUrl: config.tokenUrl,
    appId: config.appId,
    redirectUri: config.redirectUri || window.location.href,
    exitUrl: config.exitUrl,
    onUserInfoChange: (userInfo) => {
      if (userInfo) {
        console.log('User info changed:', userInfo)
      }
    },
  })
}

/**
 * 执行登录
 * @returns 登录结果
 */
export async function performLogin() {
  const loginResult = await login()
  if (loginResult.success) {
    const { token, userInfo } = loginResult
    console.log('Login successful:', { token, userInfo })
    return { success: true, token, userInfo }
  } else {
    const { errorMessage, result } = loginResult
    console.error('Login failed:', errorMessage, result)
    return { success: false, errorMessage, result }
  }
}

/**
 * 执行登出
 * @returns 登出结果
 */
export async function performLogout() {
  const logoutResult = await logout()
  if (logoutResult) {
    console.log('Logout successful')
    return true
  }
  return false
}

/**
 * 从环境变量或配置中获取 IAM 配置
 * 可以通过环境变量覆盖配置值
 * @param clientIdOverride 可选，用于覆盖 clientId（如项目 S 码）
 */
export function getIAMConfig(clientIdOverride?: string): IAMConfig {
  const baseConfig = {
    ssoUrl: process.env.REACT_APP_IAM_SSO_URL || 'https://iam-test.haier.net',
    clientId: process.env.REACT_APP_IAM_CLIENT_ID || 'S04795',
    tokenUrl: process.env.REACT_APP_IAM_TOKEN_URL || 'https://asset-sit.haier.net/assect-center/api/oauth/getTokenAndUserInfo',
    appId: process.env.REACT_APP_IAM_APP_ID || 'your app id',
    redirectUri: window.location.href,
    exitUrl: process.env.REACT_APP_IAM_EXIT_URL || 'your exit url',
  }
  return clientIdOverride
    ? { ...baseConfig, clientId: clientIdOverride }
    : baseConfig
}

